import { useState } from 'react';

const cards = [
  {
    id: 1,
    title: '《暗夜追踪》——年度悬疑烧脑神作',
    desc: '一场看似普通的失踪案，牵扯出横跨十年的惊天秘密。层层反转，结局让人拍案叫绝。豆瓣8.7分高分力荐，悬疑迷不可错过的年度最佳。',
    tag: '新上线',
    rating: '8.7',
    imageSeq: 'card-01',
  },
  {
    id: 2,
    title: '《山河故人》重映——贾樟柯经典回顾',
    desc: '跨越二十六年时光的情感史诗，用镜头记录时代变迁中个体的命运。每一个画面都是时代的切片，每一句台词都直击人心。',
    tag: '经典',
    rating: '8.5',
    imageSeq: 'card-02',
  },
  {
    id: 3,
    title: '《星际迷途》——硬核科幻视觉盛宴',
    desc: '人类文明面临终极抉择，一艘孤独的飞船承载着全人类的希望驶向未知深空。特效炸裂、设定严谨，科幻迷的饕餮大餐。',
    tag: '热播',
    rating: '9.0',
    imageSeq: 'card-03',
  },
  {
    id: 4,
    title: '《夏目友人帐》剧场版暖心上线',
    desc: '温暖治愈的经典动画回归，夏目与猫咪老师的新冒险。在这个纷繁的世界里，总有一些温柔能抚慰心灵。适合全年龄段观看。',
    tag: '治愈',
    rating: '9.2',
    imageSeq: 'card-04',
  },
  {
    id: 5,
    title: '《极限追凶》——动作片爱好者的狂欢',
    desc: '全程高能的追凶之旅，拳拳到肉的打斗场面，紧张刺激的飙车戏码。不废话、不拖沓，一部纯正的硬派动作电影。',
    tag: '劲爆',
    rating: '8.3',
    imageSeq: 'card-05',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">编辑团队每日精选，为你推荐最值得看的电影</p>
        </div>

        <div className="space-y-6">
          {cards.map((card) => (
            <CardItem key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CardItem({ card }: { card: typeof cards[0] }) {
  const [imgError, setImgError] = useState(false);

  const imageUrls: Record<string, string> = {
    'card-01': 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20movie%20scene%20with%20rain%20slicked%20city%20streets%20at%20night%20neon%20reflections%20on%20wet%20pavement%20noir%20cinematography%20warm%20street%20lamp%20glow%20suspenseful%20atmosphere%20film%20poster%20quality&width=800&height=500&seq=card-01&orientation=landscape',
    'card-02': 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20countryside%20with%20golden%20wheat%20fields%20at%20sunset%20warm%20earthy%20tones%20cinematic%20wide%20shot%20poetic%20visual%20storytelling%20soft%20natural%20light%20emotional%20atmosphere%20art%20house%20film%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
    'card-03': 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20spaceship%20orbiting%20a%20distant%20planet%20with%20nebula%20clouds%20cinematic%20space%20opera%20lighting%20dramatic%20star%20field%20background%20sleek%20futuristic%20design%20grand%20scale%20visual%20effects%20blockbuster%20quality&width=800&height=500&seq=card-03&orientation=landscape',
    'card-04': 'https://readdy.ai/api/search-image?query=Soft%20watercolor%20style%20anime%20scene%20with%20cherry%20blossoms%20and%20warm%20sunlight%20gentle%20pastel%20colors%20peaceful%20Japanese%20countryside%20healing%20atmosphere%20cozy%20vibe%20emotional%20tenderness%20ghibli%20inspired%20aesthetic&width=800&height=500&seq=card-04&orientation=landscape',
    'card-05': 'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20chase%20scene%20through%20busy%20city%20streets%20dramatic%20lighting%20explosive%20practical%20effects%20intense%20cinematography%20warm%20orange%20and%20teal%20color%20grade%20adrenaline%20fueled%20composition&width=800&height=500&seq=card-05&orientation=landscape',
  };

  return (
    <a href="#ranking" className="group flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 hover:bg-background-50 transition-all duration-300 cursor-pointer">
      <div className="relative w-full sm:w-56 h-36 rounded-lg overflow-hidden flex-shrink-0">
        {!imgError ? (
          <img
            src={imageUrls[card.imageSeq]}
            alt={card.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-movie-line text-2xl text-foreground-400"></i>
          </div>
        )}
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[10px] font-bold whitespace-nowrap">{card.tag}</span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/70 text-accent-300 text-xs font-bold whitespace-nowrap">{card.rating}分</span>
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{card.desc}</p>
        <div className="flex items-center gap-2 mt-3">
          <span className="text-xs text-accent-600 font-medium flex items-center gap-1 whitespace-nowrap">
            <i className="ri-play-circle-line"></i> 立即观看
          </span>
        </div>
      </div>
    </a>
  );
}